/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  XypeRegistrar,
  XypeRegistrarInterface,
  IMainStorage,
} from "../../contracts/XypeRegistrar";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract Registry",
            name: "registry",
            type: "address",
          },
          {
            internalType: "contract Resolver",
            name: "resolver",
            type: "address",
          },
          {
            internalType: "contract IReverseRegistrar",
            name: "reverseRegistrar",
            type: "address",
          },
          {
            internalType: "contract RootNodeController",
            name: "rootNodeController",
            type: "address",
          },
        ],
        internalType: "struct IMainStorage.DomainExternalServices",
        name: "domainServices",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "string",
            name: "domain",
            type: "string",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "gracePeriod",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "treasury",
            type: "address",
          },
          {
            internalType: "address",
            name: "paymentToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "serviceFee",
            type: "uint256",
          },
        ],
        internalType: "struct IMainStorage.DomainDeployParams",
        name: "domainDeployParam",
        type: "tuple",
      },
      {
        internalType: "contract IUniswapV2Router02",
        name: "_router",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AccessControlBadConfirmation",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "neededRole",
        type: "bytes32",
      },
    ],
    name: "AccessControlUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "AddressInsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [],
    name: "ReentrancyGuardReentrantCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32",
      },
    ],
    name: "RegistrarAliasNotAvailable",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarBatchRegisterOnBehalfInvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarBatchSetExpirationInvalidSignature",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
    ],
    name: "RegistrarChargeSubscriptionInvalidDuration",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarChargeSubscriptionInvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarDomainIsPaused",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarDomainNotLive",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarEmptyArray",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarEmptyLabel",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarEthInvalidInvestment",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarEthTransferFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarHighSlippage",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "RegistrarInvalidAliasOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposedValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "currentCounter",
        type: "uint256",
      },
    ],
    name: "RegistrarInvalidAliasesLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarInvalidCostParams",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarInvalidEthInvestment",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarInvalidInvestment",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "labelHash",
        type: "bytes32",
      },
    ],
    name: "RegistrarInvalidLabelHash",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
    ],
    name: "RegistrarInvalidPath",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "RegistrarInvalidPaymentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarInvalidStable",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "payer",
        type: "address",
      },
    ],
    name: "RegistrarInvalidSubscriptionPayer",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "treasury",
        type: "address",
      },
    ],
    name: "RegistrarInvalidTreasury",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarMultiplePrimaryAliases",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarNotEtherPayment",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarNotTldOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarOnlyAuthorized",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarOnlyAuthorizedOrNotNodeOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarOnlyOwnerOrGlobalSuperAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarOnlyRootNodeAdmins",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarRegisterInvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarRegisterOnBehalfInvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistrarRegistrationIsPaused",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "RegistrarSetPrimaryPermissionDenied",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "SafeERC20FailedOperation",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "stable",
        type: "address",
      },
    ],
    name: "AddStable",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string[]",
        name: "labels",
        type: "string[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "DeleteAlias",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32[]",
        name: "nodes",
        type: "bytes32[]",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "owners",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint64[]",
        name: "expirations",
        type: "uint64[]",
      },
      {
        indexed: false,
        internalType: "bool[]",
        name: "isPrimary",
        type: "bool[]",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "aliases",
        type: "string[]",
      },
    ],
    name: "LogBatchRegisterOnBehalf",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32[]",
        name: "nodes",
        type: "bytes32[]",
      },
      {
        indexed: false,
        internalType: "uint64[]",
        name: "expirations",
        type: "uint64[]",
      },
    ],
    name: "LogBatchSetExpiration",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "expiration",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "payment",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "paymentToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "profit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
    ],
    name: "LogChargeSubscription",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "expiration",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isPrimary",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "treasury",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "paymentToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "profit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "serviceFee",
        type: "uint256",
      },
    ],
    name: "LogRegister",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "string",
        name: "labelName",
        type: "string",
      },
    ],
    name: "LogRegisterAliasByName",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "expirations",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "LogRegisterOnBehalf",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "RegistrarDomainPaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "RegistrarRegistrationPaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "contract Registry",
            name: "registry",
            type: "address",
          },
          {
            internalType: "contract Resolver",
            name: "resolver",
            type: "address",
          },
          {
            internalType: "contract IReverseRegistrar",
            name: "reverseRegistrar",
            type: "address",
          },
          {
            internalType: "contract RootNodeController",
            name: "rootNodeController",
            type: "address",
          },
        ],
        indexed: false,
        internalType: "struct IMainStorage.DomainExternalServices",
        name: "domainExternalServices",
        type: "tuple",
      },
    ],
    name: "SetDomainServices",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldRecipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newRecipient",
        type: "address",
      },
    ],
    name: "SetFeeRecipient",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newToken",
        type: "address",
      },
    ],
    name: "SetPaymentToken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "labelHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "SetPrimaryAlias",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "SetServiceFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldTreasury",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newTreasury",
        type: "address",
      },
    ],
    name: "SetTreasuryWallet",
    type: "event",
  },
  {
    inputs: [],
    name: "BATCH_REGISTER_ON_BEHALF_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BATCH_SET_EXPIRATION_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "CHARGE_SUBSCRIPTION_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GRACE_PERIOD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MODERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REGISTER_ON_BEHALF_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REGISTER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SUPER_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseNode",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "bytes32[]",
                name: "nodes",
                type: "bytes32[]",
              },
              {
                internalType: "address[]",
                name: "owners",
                type: "address[]",
              },
              {
                internalType: "uint64[]",
                name: "expirations",
                type: "uint64[]",
              },
              {
                internalType: "bool[]",
                name: "isPrimary",
                type: "bool[]",
              },
              {
                internalType: "string[]",
                name: "aliases",
                type: "string[]",
              },
            ],
            internalType: "struct IMainStorage.BatchRegisterCore",
            name: "coreParams",
            type: "tuple",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct IMainStorage.BatchRegisterOnBehalfParam",
        name: "batchRegisterOnBehalfParam",
        type: "tuple",
      },
    ],
    name: "batchRegisterOnBehalf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32[]",
            name: "nodes",
            type: "bytes32[]",
          },
          {
            internalType: "uint64[]",
            name: "expirations",
            type: "uint64[]",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct IMainStorage.BatchSetExpirationParam",
        name: "batchSetExpirationParam",
        type: "tuple",
      },
    ],
    name: "batchSetExpiration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "labelHash",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "payer",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "duration",
            type: "uint64",
          },
          {
            internalType: "address[]",
            name: "path",
            type: "address[]",
          },
          {
            internalType: "uint256",
            name: "investment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "payment",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct IMainStorage.ChargeSubscriptionParam",
        name: "paymentParam",
        type: "tuple",
      },
    ],
    name: "chargeSubscription",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "labels",
        type: "string[]",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isForcedOwnershipTransfer",
        type: "bool",
      },
    ],
    name: "deleteAlias",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "domain",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "isAliasAvailable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isDomainActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isDomainPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isRegistrationPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paymentToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "label",
                type: "string",
              },
              {
                internalType: "uint64",
                name: "duration",
                type: "uint64",
              },
              {
                internalType: "bool",
                name: "isPrimary",
                type: "bool",
              },
            ],
            internalType: "struct IMainStorage.Label",
            name: "label",
            type: "tuple",
          },
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isLabelPaid",
            type: "bool",
          },
          {
            internalType: "address[]",
            name: "path",
            type: "address[]",
          },
          {
            internalType: "uint256",
            name: "investment",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct IMainStorage.RegisterParam",
        name: "registerParam",
        type: "tuple",
      },
    ],
    name: "register",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "label",
                type: "string",
              },
              {
                internalType: "uint64",
                name: "duration",
                type: "uint64",
              },
              {
                internalType: "bool",
                name: "isPrimary",
                type: "bool",
              },
            ],
            internalType: "struct IMainStorage.Label[]",
            name: "labels",
            type: "tuple[]",
          },
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "address",
            name: "operator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct IMainStorage.RegisterOnBehalfParam",
        name: "registerOnBehalfParam",
        type: "tuple",
      },
    ],
    name: "registerOnBehalf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "contract Registry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "callerConfirmation",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "resolver",
    outputs: [
      {
        internalType: "contract Resolver",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "reverseRegistrar",
    outputs: [
      {
        internalType: "contract IReverseRegistrar",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rootNodeController",
    outputs: [
      {
        internalType: "contract RootNodeController",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "contract IUniswapV2Router02",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "serviceFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "setDomainPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract Registry",
            name: "registry",
            type: "address",
          },
          {
            internalType: "contract Resolver",
            name: "resolver",
            type: "address",
          },
          {
            internalType: "contract IReverseRegistrar",
            name: "reverseRegistrar",
            type: "address",
          },
          {
            internalType: "contract RootNodeController",
            name: "rootNodeController",
            type: "address",
          },
        ],
        internalType: "struct IMainStorage.DomainExternalServices",
        name: "domainServicesParam",
        type: "tuple",
      },
    ],
    name: "setDomainServices",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "expiration",
        type: "uint64",
      },
    ],
    name: "setExpirationDate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeRecipient",
        type: "address",
      },
    ],
    name: "setFeeRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_paymentToken",
        type: "address",
      },
    ],
    name: "setPaymentToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "label",
        type: "string",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "setPrimary",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "setRegistrationPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_serviceFee",
        type: "uint256",
      },
    ],
    name: "setServiceFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_treasury",
        type: "address",
      },
    ],
    name: "setTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "treasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type XypeRegistrarConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XypeRegistrarConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XypeRegistrar__factory extends ContractFactory {
  constructor(...args: XypeRegistrarConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    domainServices: IMainStorage.DomainExternalServicesStruct,
    domainDeployParam: IMainStorage.DomainDeployParamsStruct,
    _router: AddressLike,
    operator: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      domainServices,
      domainDeployParam,
      _router,
      operator,
      overrides || {}
    );
  }
  override deploy(
    domainServices: IMainStorage.DomainExternalServicesStruct,
    domainDeployParam: IMainStorage.DomainDeployParamsStruct,
    _router: AddressLike,
    operator: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      domainServices,
      domainDeployParam,
      _router,
      operator,
      overrides || {}
    ) as Promise<
      XypeRegistrar & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): XypeRegistrar__factory {
    return super.connect(runner) as XypeRegistrar__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XypeRegistrarInterface {
    return new Interface(_abi) as XypeRegistrarInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): XypeRegistrar {
    return new Contract(address, _abi, runner) as unknown as XypeRegistrar;
  }
}
